import I18n from 'i18n-js';
import React from 'react';
import { SectionTitle } from 'components';
import SectionWrapper from 'components/SectionWrapper/SectionWrapper';

import OnboardingPerfilDeConsumo from 'types/models/onboardingPertfilConsumo';
import styles from './onboarding-perfil-consumo-list-table.module.scss';
import { OnboardingPerfilConsumoListRow } from '../onboarding-perfil-consumo-list-row/onboarding-perfil-consumo-list-row';

interface OnboardingPerfilConsumoListTableProps {
  data: OnboardingPerfilDeConsumo[];
  solicitudID: string;
  onChange: CallableFunction;
}

export const OnboardingPerfilConsumoListTable = (props: OnboardingPerfilConsumoListTableProps): JSX.Element => {
  const { data, onChange } = props;
  const { t } = I18n;

  return (
    <div className={styles.root}>
      <SectionWrapper>
        <div className={styles.table_wrapper2}>
          <div className={styles.titleWrapper}>
            <SectionTitle text={I18n.t('OnboardingListPage.title')} />
          </div>

          <table className={styles.table_wrapper}>
            {data.length > 0 ? (
              <>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>{t(`OnboardingListPage.headers.perfilConsumidor`)}</th>
                    <th>{t(`OnboardingListPage.headers.curvaConsumo`)}</th>
                    <th>{t(`OnboardingListPage.headers.fechaActualizacion`)}</th>
                    <th aria-label="Detail" />
                  </tr>
                </thead>
                <tbody>
                  {data.map((configuracion) => (
                    <OnboardingPerfilConsumoListRow
                      key={configuracion.id}
                      configuracion={configuracion}
                      deleteOnChange={onChange}
                    />
                  ))}
                </tbody>
              </>
            ) : (
              <p>{t(`TarifasListPage.headers.notResult`)}</p>
            )}
          </table>
        </div>
      </SectionWrapper>
    </div>
  );
};
